// Generated by CoffeeScript 2.7.0
var AttributeSet, generateDataKey;

import Utilities from 'helpers/utilities.js';

({generateDataKey} = Utilities);

import Delegator from './delegator.js';

export default AttributeSet = class AttributeSet extends Delegator {
  data(attr_name, val) {
    attr_name = this._generateAttributeName(attr_name);
    if (val === void 0) {
      return this.delegator.node.getAttribute(attr_name);
    } else {
      return this.delegator.node.setAttribute(attr_name, val);
    }
  }

  removeData(attr_name) {
    attr_name = this._generateAttributeName(attr_name);
    return this.delegator.node.removeAttribute(attr_name);
  }

  _generateAttributeName(attr_name) {
    return `data-${generateDataKey(attr_name)}`;
  }

};
